import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../PropertiesMenuStyles';
import { TYPES, PROPERTY_PANELS, BACKGROUND_IMAGE_TYPE } from 'crazyEditor/core/constants/panelConstants';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import CustomSvgButtonWithTextPropMenu from '../../shared/CustomSvgButtonWithTextPropMenu';
import { getElementDefinitionProps, isChildElement } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

@connect(
  false,
  {openLazyPanel}
)
@Radium
export default class BackgroundProperty extends Component {
  openPanel = (event, panel, panelProps = {}) => {
    const {openLazyPanel, selectedElementIds, selectedElements} = this.props;
    openLazyPanel(panel, TYPES.PROPERTY_PANEL, event.currentTarget, {
      selectedElementIds: selectedElementIds,
      selectedElements: selectedElements,
      ...panelProps
    });
  };

  render() {
    const {selectedElements} = this.props;
    const elementDefinitionProps = getElementDefinitionProps(selectedElements[0].type);
    const noTextureFill = elementDefinitionProps.noTextureFill || isChildElement(selectedElements[0]);
    let title;
    let propNameToUpdate;
    if (elementDefinitionProps.backgroundColorProp) {
      title = 'Fill';
      propNameToUpdate = elementDefinitionProps.backgroundColorProp;
    } else {
      title = 'Background';
      propNameToUpdate = 'compProps.backgroundColor';
    }
    return (
      <div style={[baseStyles.menuContainer, this.props.first && baseStyles.menuContainerFirst]}>
        <div style={baseStyles.menuTitle}>{title}</div>
        <div style={baseStyles.menuBody}>
          <CustomSvgButtonWithTextPropMenu label="Color"
                                           iconWidth="28px"
                                           iconHeight="28px"
                                           lineBackground={_.get(selectedElements[0], propNameToUpdate) || 'transparent'}
                                           onClick={(event) => this.openPanel(event, PROPERTY_PANELS.COLOR, {propNameToUpdate})}
                                           iconPath="M19,11.5C19,11.5 17,13.67 17,15A2,2 0 0,0 19,17A2,2 0 0,0 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z"/>
          {
            !noTextureFill &&
              [
                (<CustomSvgButtonWithTextPropMenu key="Texture"
                                                  label="Texture"
                                                  iconWidth="36px"
                                                  iconHeight="36px"
                                                  onClick={(event) => this.openPanel(event, PROPERTY_PANELS.TEXTURE_OR_GRADIENT, {type: BACKGROUND_IMAGE_TYPE.TEXTURE})}
                                                  iconPath="M9.29,21H12.12L21,12.12V9.29M19,21C19.55,21 20.05,20.78 20.41,20.41C20.78,20.05 21,19.55 21,19V17L17,21M5,3A2,2 0 0,0 3,5V7L7,3M11.88,3L3,11.88V14.71L14.71,3M19.5,3.08L3.08,19.5C3.17,19.85 3.35,20.16 3.59,20.41C3.84,20.65 4.15,20.83 4.5,20.92L20.93,4.5C20.74,3.8 20.2,3.26 19.5,3.08Z"/>),
                (<CustomSvgButtonWithTextPropMenu key="Gradient"
                                                  iconProps={{
                                                    viewBox: '0 0 30 30'
                                                  }}
                                                  iconWidth="30px"
                                                  iconHeight="30px"
                                                  label="Gradient"
                                                  onClick={(event) => this.openPanel(event, PROPERTY_PANELS.TEXTURE_OR_GRADIENT, {type: BACKGROUND_IMAGE_TYPE.GRADIENT})}
                                                  iconPath="M13.44,10.33h3.11v3.11H13.44V10.33Zm-3.11,3.11h3.11v3.11H10.33V13.44Zm6.22,0h3.11v3.11H16.56V13.44Zm3.11-3.11h3.11v3.11H19.67V10.33Zm-12.44,0h3.11v3.11H7.22V10.33ZM25.89,1H4.11A3.12,3.12,0,0,0,1,4.11V25.89A3.12,3.12,0,0,0,4.11,29H25.89A3.12,3.12,0,0,0,29,25.89V4.11A3.12,3.12,0,0,0,25.89,1ZM10.33,24.33H7.22V21.22h3.11v3.11Zm6.22,0H13.44V21.22h3.11v3.11Zm6.22,0H19.67V21.22h3.11v3.11Zm3.11-10.89H22.78v3.11h3.11v3.11H22.78V16.56H19.67v3.11H16.56V16.56H13.44v3.11H10.33V16.56H7.22v3.11H4.11V16.56H7.22V13.44H4.11V4.11H25.89v9.33Z"/>)
              ]
          }
        </div>
      </div>
    );
  }
}

BackgroundProperty.propTypes = {
  selectedElementIds: PropTypes.array.isRequired,
  selectedElements: PropTypes.array.isRequired,
  elementDefinitionProps: PropTypes.object.isRequired
};